import axios from 'axios';

// axios.defaults.timeout = 5000; // 设置请求超时时间
console.log('process.env.NODE_ENV', process.env.NODE_ENV)
const api = axios.create({
    baseURL: process.env.NODE_ENV === "development" ? "https://www.zhuhua.cn/" : "https://www.zhuhua.cn/", // 设置你的API基础URL
    headers: {
        'Content-Type': 'application/json'
    }
});

export default {
    //查询所有秒杀专场(分页)
    seckillVenuepage(data) {
        return api.post('/seckill/seckillVenue/page', data, {
            headers: {
              'Content-Type': 'application/json'
            } // 将传入的headers对象作为请求的headers
          })
            .then(res => {
              return res.data;
            })
            .catch(error => {
              // 处理请求错误
              console.error(error);
              throw error;
            });
    },
    //删除秒杀专场
    remove(data){
        return api.delete('/seckill/seckillVenue/remove/'+data, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            } // 将传入的headers对象作为请求的headers
          })
            .then(res => {
              return res.data;
            })
            .catch(error => {
              // 处理请求错误
              console.error(error);
              throw error;
            });
    },
    //查询所有秒杀商品(分页)
    seckillProductpage(data){
        return api.post('/seckill/seckillProduct/page', data, {
            headers: {
              'Content-Type': 'application/json'
            } // 将传入的headers对象作为请求的headers
          })
            .then(res => {
              return res.data;
            })
            .catch(error => {
              // 处理请求错误
              console.error(error);
              throw error;
            });
    }

}